// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1_TZY","inputDescription":"styles_inputDescription__1oQw-"};